import React, { useEffect } from 'react';
import { FiCheck } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import AnnouncementBar from './AnnouncementBar';
import Header from './Header';
import Footer from './Footer';
import Credentials from './Credentials';
import AboutCertificate from './AboutCertificate';

const traits = [
  'Calm under pressure',
  'Detail-oriented',
  'Patient and methodical',
  'Bilingual EN & PT'
];

const AboutPage = () => {
  useEffect(() => {
    document.title =
      'About Carlos Dasilva | Pronto Notary | Maryland Commissioned Notary Public';

    const description =
      "Meet Carlos Dasilva, a Maryland-commissioned notary public serving Prince George's and Montgomery County. Bilingual in English and Português, NNA member, background screened.";

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;

    return () => {
      document.title = 'Pronto Notary | Mobile Notary & Apostille Services';
    };
  }, []);

  return (
    <div className="min-h-screen bg-cream text-navy">
      <AnnouncementBar />
      <Header />
      <main>
        <section className="px-6 pb-20 pt-16 md:pb-28 md:pt-24">
          <div className="mx-auto max-w-7xl">
            <span className="mb-5 block text-xs font-bold uppercase tracking-[0.2em] text-brass">
              WHY WE STARTED PRONTO
            </span>
            <h1 className="max-w-4xl font-fraunces text-4xl leading-tight md:text-6xl">
              This business started{' '}
              <span className="italic text-brass">
                with a phone call to my grandfather.
              </span>
            </h1>

            <div className="mt-14 grid grid-cols-1 items-start gap-14 lg:grid-cols-2 lg:gap-20">
              <AboutCertificate />

              <div className="space-y-6 text-lg leading-relaxed text-navy/80">
                <p className="font-fraunces text-2xl italic leading-relaxed text-navy md:text-3xl">
                  A few years ago, when an elderly relative needed to be moved
                  into assisted living, our family had to track down a notary
                  fast to get a power of attorney signed. It was harder than it
                  should have been.
                </p>
                <p>
                  Hi, I&apos;m Carlos. I&apos;ve spent over a decade as an
                  operations manager, the person who keeps complicated things
                  running smoothly. I&apos;m calm under pressure and careful with
                  details.
                </p>
                <p>
                  I was born in the US to Brazilian parents who came here from
                  São Paulo. My mom still gets nervous around official documents
                  in English, and she&apos;s not alone. That&apos;s why Pronto
                  Notary exists.
                </p>
                <p>
                  If you&apos;re a Brazilian family with paperwork heading back
                  to São Paulo, we speak your language. If you need something
                  signed at 8pm on a Tuesday, we work then. If you&apos;re in a
                  hospital room with a parent who needs a power of attorney,
                  we&apos;ll be there as fast as we can.
                </p>
                <p className="font-fraunces text-2xl italic text-navy">
                  That&apos;s the whole idea.
                </p>

                <div className="flex flex-wrap gap-3 pt-4">
                  {traits.map((trait) => (
                    <div
                      key={trait}
                      className="flex items-center gap-2 rounded-full border border-line bg-cream-light px-4 py-2 text-sm font-semibold text-navy/70"
                    >
                      <SafeIcon icon={FiCheck} className="text-brass" />
                      {trait}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <Credentials />

        <section className="bg-cream px-6 py-20 text-center md:py-24">
          <div className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-4 sm:flex-row">
            <a
              href="/contact"
              className="w-full rounded-full bg-navy px-7 py-3.5 text-sm font-bold text-cream transition-colors hover:bg-brass sm:w-auto"
            >
              Book Your Appointment
            </a>
            <a
              href="tel:2405713117"
              className="w-full rounded-full border border-navy/30 px-7 py-3.5 text-sm font-semibold text-navy transition-colors hover:border-brass hover:text-brass sm:w-auto"
            >
              Call or Text (240) 571-3117
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;